<template>
  <component
    :is="iconComponent"
    v-if="iconComponent"
    class="base-icon custom"
    v-bind="svgProps"
    @click="$emit('click', $event)"
  />
  <img
    v-else-if="isImage"
    :src="imageSource"
    :alt="icon.alt || icon.name"
    :aria-hidden="true"
    @click="$emit('click', $event)"
  >
  <span
    v-else
    :key="icon"
    class="base-icon"
    @click="$emit('click', $event)"
  >
    <i :class="icon" />
  </span>
</template>

<script>
import components from './icons';

export default {
  name: 'BaseIcon',
  components,
  props: {
    icon: {
      type: [String, Object],
      default: '',
    },
    svgProps: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['click'],
  data() {
    return {
      iconComponent: this.getIconComponentName(this.icon),
    };
  },
  computed: {
    isImage() {
      return typeof this.icon === 'object';
    },
    imageSource() {
      return `${this.icon.url}/${this.icon.name}`;
    },
  },
  watch: {
    icon(newIcon, oldIcon) {
      if (newIcon !== oldIcon) {
        this.iconComponent = this.getIconComponentName(newIcon);
      }
    },
  },
  methods: {
    getIconComponentName(icon) {
      const fallbackComponentName = null;
      const componentName = `Icon${icon}`;

      return Object.keys(components).indexOf(componentName) < 0
        ? fallbackComponentName
        : componentName;
    },
  },
};
</script>

<style lang="scss" scoped>
.base-icon.custom {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
